import React from 'react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_image_model_path } from '@/modules/routes';
import { QueryKeys } from '@/components/admin/QuestionImage/utils';
import IImageModel from '@/components/interfaces/ImageModel';
import { useModalManager } from '@/components/common/Modal';
import ConfirmDeleteModal from '@/components/common/Modal/ConfirmDeleteModal';
import I18n from 'i18n-js';
import Icon from '@/components/ui/Icon';

interface DeleteProps {
  afterDelete: (id?: number) => any;
  imageModel: Omit<IImageModel, 'image'>;
  useIconOnly?: boolean;
}

const Delete = ({ afterDelete, imageModel, useIconOnly = false }: DeleteProps) => {
  const deleteModalManager = useModalManager();
  const { mutate, isLoading } = useMutation({
    mutationFn: () => (
      axios
        .delete(plato_api_image_model_path(imageModel.id))
        .then(() => afterDelete(imageModel.id))
    ),
    mutationKey: [QueryKeys.ImageModels, QueryKeys.Delete, imageModel.id],
  });

  return (
    <>
      {deleteModalManager.isOpen && (
        <ConfirmDeleteModal
          confirmationText={I18n.t('delete_image_message')}
          confirmButtonText={I18n.t('delete')}
          headerText={I18n.t('delete_image')}
          isLoading={isLoading}
          isOpen={deleteModalManager.isOpen}
          onCancel={deleteModalManager.close}
          onConfirm={mutate}
        />
      )}
      {useIconOnly ? (
        <button
          aria-label={I18n.t('delete')}
          style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}
          type="button"
          onClick={deleteModalManager.open}
        >
          <Icon
            className="tw-text-red"
            icon="Delete"
            size={22}
            style={{ pointerEvents: 'none' }}
          />
        </button>
      ) : (
        <button
          className="btn btn--red btn--sm"
          disabled={isLoading}
          type="button"
          onClick={deleteModalManager.open}
        >
          Delete
        </button>
      )}
    </>
  );
};

export default Delete;
